var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "live-event-component",
      attrs: {
        idfoevent: _vm.event.idfoevent.toString(),
        idfosbevent: _vm.event.idfosbevent && _vm.event.idfosbevent.toString(),
        idextevent: _vm.event.idextevent && _vm.event.idextevent.toString()
      }
    },
    [
      _vm.isDebug
        ? _c("div", { staticClass: "debug" }, [
            _vm._v("\n    idfoevent " + _vm._s(_vm.event.idfoevent)),
            _c("br"),
            _vm._v("\n    idfosbevent " + _vm._s(_vm.event.idfosbevent)),
            _c("br"),
            _vm._v(
              "\n    eventdisplayorder " +
                _vm._s(_vm.event.eventdisplayorder) +
                " "
            ),
            _c("br"),
            _vm._v("\n    eventrows " + _vm._s(_vm.event.eventrows) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-row" },
        [
          _vm.awayPlayer && _vm.homePlayer && !_vm.event.isoutright
            ? _c("div", { staticClass: "event-info" }, [
                _c("div", { staticClass: "info-head" }, [
                  _vm.showheader === undefined || _vm.showheader
                    ? _c(
                        "h2",
                        { staticClass: "sport-name" },
                        [
                          (_vm.brand_translux4 &&
                            !_vm.isSportIconAvailableForTranslux4) ||
                          _vm.brand_translux3 ||
                          _vm.brand_translux2
                            ? _c("img", {
                                staticClass: "logo",
                                attrs: {
                                  src: "static/img/logo-event.png",
                                  alt: "Logo"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.brand_translux4 &&
                          _vm.isSportIconAvailableForTranslux4
                            ? _c("icon", {
                                attrs: {
                                  name:
                                    "icon-" +
                                    _vm.event.fosporttypename.replace(/ /g, ""),
                                  colorName: "translux4"
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.headertype === "DATE"
                            ? [
                                _vm.isDateToday
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("Today")) +
                                          "\n            "
                                      )
                                    ]
                                  : _vm.isDateTomorrow
                                  ? [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.$t("Tomorrow")) +
                                          "\n            "
                                      )
                                    ]
                                  : [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.event.tsDate) +
                                          "\n            "
                                      )
                                    ]
                              ]
                            : [
                                _vm._v(
                                  _vm._s(
                                    _vm.event.fosporttypename ||
                                      _vm.event.idfosporttype
                                  )
                                )
                              ]
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "names-date" }, [
                    _c(
                      "div",
                      {
                        staticClass: "listcode-date",
                        class: { showparticipantlogo: _vm.teamLogoVisibility }
                      },
                      [
                        !(
                          _vm.brand_translux4 ||
                          _vm.brand_translux3 ||
                          _vm.brand_translux2
                        )
                          ? _c("span", { staticClass: "listcode" }, [
                              _vm._v(_vm._s(_vm.listCode.away || "-"))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "time" }, [
                          _c(
                            "span",
                            [
                              !_vm.event.isawaitingstart
                                ? _c(
                                    "span",
                                    {
                                      class: {
                                        "live-icon": !_vm.event.isawaitingstart
                                      }
                                    },
                                    [_vm._v("LIVE")]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.event.periodname))
                              ]),
                              _vm._v(" "),
                              [
                                "FOOTBALL",
                                "SOCCER",
                                "BASKETBALL",
                                "HANDBALL",
                                "ICE HOCKEY"
                              ].indexOf(_vm.event.idfosporttype) > -1
                                ? [
                                    !_vm.matchTimer &&
                                    _vm.event.istimeractive &&
                                    _vm.event.matchcurrenttimeinmins
                                      ? _c(
                                          "span",
                                          { staticClass: "time-counter" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.event.matchcurrenttimeinmins
                                              ) + "'"
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.matchTimer
                                      ? _c("match-time-display", {
                                          attrs: { timer: _vm.matchTimer }
                                        })
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]),
                        _vm._v(" "),
                        !(
                          _vm.brand_translux4 ||
                          _vm.brand_translux3 ||
                          _vm.brand_translux2
                        )
                          ? _c("span", { staticClass: "listcode" }, [
                              _vm._v(_vm._s(_vm.listCode.home || "-"))
                            ])
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    !_vm.isSportReverseParticipants
                      ? _c(
                          "div",
                          {
                            staticClass: "names",
                            class: { "team-logos": _vm.teamLogoVisibility }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "away",
                                class: { server: _vm.isAwayServing }
                              },
                              [
                                _vm.brand_translux4 ||
                                _vm.brand_translux3 ||
                                _vm.brand_translux2
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.away || "-"))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showparticipantlogo
                                  ? _c("span", {
                                      staticClass: "team-logo",
                                      style: _vm.awayTeamLogoStyle
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "team-name" }, [
                                  _vm._v(_vm._s(_vm.awayPlayer.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "home",
                                class: { server: _vm.isHomeServing }
                              },
                              [
                                _vm.brand_translux4 ||
                                _vm.brand_translux3 ||
                                _vm.brand_translux2
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.home || "-"))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showparticipantlogo
                                  ? _c("span", {
                                      staticClass: "team-logo",
                                      style: _vm.homeTeamLogoStyle
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "team-name" }, [
                                  _vm._v(_vm._s(_vm.homePlayer.name))
                                ])
                              ]
                            )
                          ]
                        )
                      : _c(
                          "div",
                          {
                            staticClass: "names",
                            class: { "team-logos": _vm.teamLogoVisibility }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "home",
                                class: { server: _vm.isHomeServing }
                              },
                              [
                                _vm.brand_translux4 ||
                                _vm.brand_translux3 ||
                                _vm.brand_translux2
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.home || "-"))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showparticipantlogo
                                  ? _c("span", {
                                      staticClass: "team-logo",
                                      style: _vm.homeTeamLogoStyle
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "team-name" }, [
                                  _vm._v(_vm._s(_vm.homePlayer.name))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "away",
                                class: { server: _vm.isAwayServing }
                              },
                              [
                                _vm.brand_translux4 ||
                                _vm.brand_translux3 ||
                                _vm.brand_translux2
                                  ? _c("span", { staticClass: "listcode" }, [
                                      _vm._v(_vm._s(_vm.listCode.away || "-"))
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.showparticipantlogo
                                  ? _c("span", {
                                      staticClass: "team-logo",
                                      style: _vm.awayTeamLogoStyle
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "team-name" }, [
                                  _vm._v(_vm._s(_vm.awayPlayer.name))
                                ])
                              ]
                            )
                          ]
                        )
                  ])
                ]),
                _vm._v(" "),
                !_vm.hideScores
                  ? _c("div", { staticClass: "info" }, [
                      _c("table", [
                        _vm.showheader === undefined || _vm.showheader
                          ? _c("thead", [
                              _c(
                                "tr",
                                { staticClass: "header-row" },
                                [
                                  _vm.event.idfosporttype !== "TENNIS" ||
                                  ((_vm.brand_white1 || _vm.brand_translux5) &&
                                    _vm.event.idfosporttype === "TENNIS")
                                    ? _c("th", {
                                        staticClass: "final-result",
                                        domProps: {
                                          textContent: _vm._s(
                                            (_vm.brand_white1 ||
                                              _vm.brand_translux5) &&
                                              _vm.event.idfosporttype ===
                                                "TENNIS"
                                              ? "S"
                                              : _vm.$t("Results.FSC")
                                          )
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "SOCCER"
                                    ? _c("th", { staticClass: "halftime" }, [
                                        _vm._v(_vm._s(_vm.$t("Results.HT")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.event.idfosporttype === "TENNIS" &&
                                  _vm.awayPlayerScores.length > 0
                                    ? [
                                        _c("th", {
                                          staticClass: "score serve"
                                        }),
                                        _vm._v(" "),
                                        _vm.brand_white1 || _vm.brand_translux5
                                          ? _c(
                                              "th",
                                              { staticClass: "score set" },
                                              [_vm._v("G")]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("th", { staticClass: "game" }, [
                                          _vm._v("P")
                                        ])
                                      ]
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm._l(_vm.awayPlayerScores, function(score) {
                                    return [
                                      "TENNIS",
                                      "BASKETBALL",
                                      "ICE HOCKEY",
                                      "BASEBALL",
                                      "NFL"
                                    ].indexOf(_vm.event.idfosporttype) > -1
                                      ? _c("th", { staticClass: "period" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                _vm.getScoreKeyBySport(
                                                  score,
                                                  _vm.event.idfosporttype
                                                )
                                              ) +
                                              "\n              "
                                          )
                                        ])
                                      : _vm._e()
                                  })
                                ],
                                2
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("tbody", [
                          _c(
                            "tr",
                            { staticClass: "away" },
                            [
                              _vm.event.idfosporttype !== "TENNIS" ||
                              _vm.brand_white1 || _vm.brand_translux5
                                ? _c("td", { staticClass: "score match" }, [
                                    !_vm.isSportReverseParticipants
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.awayPlayerMainScore &&
                                                _vm.awayPlayerMainScore.value
                                            )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.homePlayerMainScore &&
                                                _vm.homePlayerMainScore.value
                                            )
                                          )
                                        ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "SOCCER"
                                ? [
                                    _c(
                                      "td",
                                      { staticClass: "score halftime" },
                                      [
                                        _vm.event.idfosbactiveperiod ===
                                        "FBL1HLF"
                                          ? _c("span", [_vm._v(" - ")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.event.idfosbactiveperiod !==
                                        "FBL1HLF"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.soccerAwayHTScore &&
                                                      _vm.soccerAwayHTScore
                                                        .value
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "TENNIS" &&
                              _vm.awayPlayerScores.length > 0
                                ? [
                                    _c("td", { staticClass: "score serve" }, [
                                      _vm.awayPlayer.idfosblead ===
                                        _vm.liveEvent.idfosbleadactive ||
                                      _vm.awayPlayer.flag1
                                        ? _c("span", [_vm._v("*")])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _vm.brand_white1 || _vm.brand_translux5
                                      ? _c("td", { staticClass: "score set" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.awayPlayerTennisSetScores
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("td", { staticClass: "score game" }, [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            (!_vm.isTieBreakActive &&
                                              _vm.tennisAwayPlayerGameScore &&
                                              _vm.tennisAwayPlayerGameScore
                                                .value &&
                                              _vm.gameScoreMap[
                                                _vm.tennisAwayPlayerGameScore
                                                  .value
                                              ]) ||
                                              (_vm.tennisAwayPlayerGameScore &&
                                                _vm.tennisAwayPlayerGameScore
                                                  .value)
                                          )
                                        )
                                      ])
                                    ])
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              [
                                "TENNIS",
                                "BASKETBALL",
                                "ICE HOCKEY",
                                "BASEBALL",
                                "NFL"
                              ].indexOf(_vm.event.idfosporttype) > -1
                                ? _vm._l(_vm.awayPlayerScores, function(score) {
                                    return _c(
                                      "td",
                                      { staticClass: "score period" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.getScore(score).value) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "tr",
                            { staticClass: "home" },
                            [
                              _vm.event.idfosporttype !== "TENNIS" ||
                              _vm.brand_white1 || _vm.brand_translux5
                                ? _c("td", { staticClass: "score match" }, [
                                    !_vm.isSportReverseParticipants
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.homePlayerMainScore &&
                                                _vm.homePlayerMainScore.value
                                            )
                                          )
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.awayPlayerMainScore &&
                                                _vm.awayPlayerMainScore.value
                                            )
                                          )
                                        ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "SOCCER"
                                ? [
                                    _c(
                                      "td",
                                      { staticClass: "score halftimescore" },
                                      [
                                        _vm.event.idfosbactiveperiod ===
                                        "FBL1HLF"
                                          ? _c("span", [_vm._v(" - ")])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.event.idfosbactiveperiod !==
                                        "FBL1HLF"
                                          ? _c("span", [
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(
                                                    _vm.soccerHomeHTScore &&
                                                      _vm.soccerHomeHTScore
                                                        .value
                                                  ) +
                                                  "\n                  "
                                              )
                                            ])
                                          : _vm._e()
                                      ]
                                    )
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.event.idfosporttype === "TENNIS" &&
                              _vm.homePlayerScores.length > 0
                                ? [
                                    _c("td", { staticClass: "score serve" }, [
                                      _vm.homePlayer.idfosblead ===
                                        _vm.liveEvent.idfosbleadactive ||
                                      _vm.homePlayer.flag1
                                        ? _c("span", [_vm._v("*")])
                                        : _vm._e()
                                    ]),
                                    _vm._v(" "),
                                    _vm.brand_white1 || _vm.brand_translux5
                                      ? _c("td", { staticClass: "score set" }, [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.homePlayerTennisSetScores
                                              )
                                            )
                                          ])
                                        ])
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.event.idfosporttype === "TENNIS"
                                      ? _c(
                                          "td",
                                          { staticClass: "score game" },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  (!_vm.isTieBreakActive &&
                                                    _vm.tennisHomePlayerGameScore &&
                                                    _vm
                                                      .tennisHomePlayerGameScore
                                                      .value &&
                                                    _vm.gameScoreMap[
                                                      _vm
                                                        .tennisHomePlayerGameScore
                                                        .value
                                                    ]) ||
                                                    (_vm.tennisHomePlayerGameScore &&
                                                      _vm
                                                        .tennisHomePlayerGameScore
                                                        .value)
                                                )
                                              )
                                            ])
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              [
                                "TENNIS",
                                "BASKETBALL",
                                "ICE HOCKEY",
                                "BASEBALL",
                                "NFL"
                              ].indexOf(_vm.event.idfosporttype) > -1
                                ? _vm._l(_vm.homePlayerScores, function(score) {
                                    return _c(
                                      "td",
                                      { staticClass: "score period" },
                                      [
                                        _vm._v(
                                          "\n                  " +
                                            _vm._s(_vm.getScore(score).value) +
                                            "\n                "
                                        )
                                      ]
                                    )
                                  })
                                : _vm._e()
                            ],
                            2
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.event.isoutright
            ? _c("div", { staticClass: "event-info" }, [
                _c(
                  "div",
                  { staticClass: "info-head" },
                  [
                    _c("h2", { staticClass: "sport-name" }, [
                      _vm._v(_vm._s(_vm.event.idfosporttype))
                    ]),
                    _vm._v(" "),
                    (_vm.brand_translux4 &&
                      !_vm.isSportIconAvailableForTranslux4) ||
                    _vm.brand_translux4 ||
                    _vm.brand_translux3 ||
                    _vm.brand_translux2
                      ? _c("img", {
                          staticClass: "logo",
                          attrs: {
                            src: "static/img/logo-event.png",
                            alt: "Logo"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.brand_translux4 && _vm.isSportIconAvailableForTranslux4
                      ? _c("icon", {
                          attrs: {
                            name:
                              "icon-" +
                              _vm.event.fosporttypename.replace(/ /g, ""),
                            colorName: "translux4"
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "names-date" }, [
                      _c(
                        "div",
                        {
                          staticClass: "listcode-date",
                          class: { showparticipantlogo: _vm.teamLogoVisibility }
                        },
                        [
                          _c("span", { staticClass: "listcode" }, [
                            _vm._v(_vm._s(_vm.listCode.away || "-"))
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "time" }, [
                            _vm.event.idfobolifestate === "O"
                              ? _c("span", [
                                  _vm.isDateToday
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(_vm._s(_vm.$t("Today")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.isDateTomorrow
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(_vm._s(_vm.$t("Tomorrow")))
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.isDateToday && !_vm.isDateTomorrow
                                    ? _c("span", { staticClass: "day" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm._f("moment")(
                                              _vm.event.tsExpectedStart,
                                              _vm.dateFormats.dayNameDayAndMonth
                                            )
                                          )
                                        )
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "hour" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          _vm.event.tsExpectedStart,
                                          _vm.dateFormats.shortTime
                                        )
                                      ) +
                                        " " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.event.tsExpectedStart,
                                            "A"
                                          )
                                        )
                                    )
                                  ])
                                ])
                              : _c("span", [_vm._v(_vm._s(_vm.$t("Finished")))])
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "listcode" }, [
                            _vm._v(_vm._s(_vm.listCode.home || "-"))
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "names" }, [
                        _c("span", [
                          _c("span", { staticClass: "team-name" }, [
                            _vm._v(
                              _vm._s(
                                _vm.event.markets &&
                                  _vm.event.markets[0] &&
                                  _vm.event.markets[0].eventname
                              )
                            )
                          ])
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.popularMarkets.length > 0 ||
          _vm.screenConfiguration.is2showeventsin2columns ||
          _vm.screenConfiguration.is2showsingleevent
            ? _c("markets", {
                staticClass: "markets-container",
                attrs: {
                  event: _vm.event,
                  markets: _vm.popularMarkets,
                  is2displayhorizontally: _vm.event.is2displayhorizontally,
                  showheader: _vm.showheader
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "expanded-markets",
          class: {
            open:
              _vm.event.idfobolifestate === "O" &&
              _vm.expandedMarkets.length > 0
          }
        },
        [
          _vm.event.idfobolifestate === "O" && _vm.expandedMarkets.length > 0
            ? _c("markets", {
                staticClass: "markets-container",
                attrs: {
                  event: _vm.event,
                  markets: _vm.expandedMarkets,
                  is2displayhorizontally: _vm.event.is2displayhorizontally
                }
              })
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-021ce0dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-021ce0dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bettingoffer/live/liveEvent.vue
// module id = null
// module chunks = 